import React from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "../../App";
import ExperienceIndex from "../hot-tubs-ar";
import ExperienceListing from "../hot-tubs-ar/index-listing";
import ExperienceSingle from "../hot-tubs-ar/single";
import SwitchableIndex from "../switchable";
import SwitchableSingle from "../switchable/single";
import SwitchableListing from "../switchable/index-listing";
import { loader_getAllSwitchables } from "../switchable/functions";
import SwitchableViewer from "../switchable/viewer";

const ApplicationRouter = createBrowserRouter([
  // Placeholder
  {
    path: "/",
    element: <App />,
  },
  // Saunas
  {
    path: "/saunas",
    element: <SwitchableIndex dataType="saunas" />,
    children: [
      {
        path: "",
        element: <SwitchableListing />,
        loader: loader_getAllSwitchables("saunas"),
      },
      {
        path: ":experienceID",
        element: <SwitchableSingle />,
      },
    ],
  },
  // Massage Chairs
  {
    path: "/massagechairs",
    element: <SwitchableIndex dataType="chairs" />,
    children: [
      {
        path: "",
        element: <SwitchableListing />,
        loader: loader_getAllSwitchables("chairs"),
      },
      {
        path: ":experienceID",
        element: <SwitchableSingle />,
      },
    ],
  },
  // Internal viewers
  {
    path: "/viewer/saunas/:experienceID",
    element: <SwitchableViewer dataType="saunas" />,
  },
  {
    path: "/viewer/massagechairs/:experienceID",
    element: <SwitchableViewer dataType="chairs" />,
  },
  // Jacuzzi Hot Tubs
  {
    path: "/jacuzzi-hot-tubs",
    element: <ExperienceIndex companyName="jacuzzi-hot-tubs" />,
    children: [
      {
        path: "",
        element: <ExperienceListing companyName="jacuzzi-hot-tubs" />,
        // loader: loader_ListAllExperiences,
      },
      {
        path: ":experienceID",
        element: <ExperienceSingle companyName="jacuzzi-hot-tubs" />,
      },
    ],
  },
  // Sun&Soul Spas and swim spas
  {
    path: "/sun-and-soul-spas",
    element: <ExperienceIndex companyName="sun-and-soul-spas" />,
    children: [
      {
        path: "",
        element: <ExperienceListing companyName="sun-and-soul-spas" />,
        // loader: loader_ListAllExperiences,
      },
      {
        path: ":experienceID",
        element: <ExperienceSingle companyName="sun-and-soul-spas" />,
      },
    ],
  },
  // Dimension One Spas
  {
    path: "/dimension-one-spas",
    element: <ExperienceIndex companyName="dimension-one-spas" />,
    children: [
      {
        path: "",
        element: <ExperienceListing companyName="dimension-one-spas" />,
      },
      {
        path: ":experienceID",
        element: <ExperienceSingle companyName="dimension-one-spas" />,
      },
    ],
  },
  // Sundance Spas
  {
    path: "/sundance-spas",
    element: <ExperienceIndex companyName="sundance-spas" />,
    children: [
      {
        path: "",
        element: <ExperienceListing companyName="sundance-spas" />,
      },
      {
        path: ":experienceID",
        element: <ExperienceSingle companyName="sundance-spas" />,
      },
    ],
  },
  // Sundance SwimSpas
  {
    path: "/sundance-swim-spas",
    element: <ExperienceIndex companyName="sundance-swim-spas" />,
    children: [
      {
        path: "",
        element: <ExperienceListing companyName="sundance-swim-spas" />,
      },
      {
        path: ":experienceID",
        element: <ExperienceSingle companyName="sundance-swim-spas" />,
      },
    ],
  },
  // Jacuzzi Swim Spas
  {
    path: "/jacuzzi-swim-spas",
    element: <ExperienceIndex companyName="jacuzzi-swim-spas" />,
    children: [
      {
        path: "",
        element: <ExperienceListing companyName="jacuzzi-swim-spas" />,
      },
      {
        path: ":experienceID",
        element: <ExperienceSingle companyName="jacuzzi-swim-spas" />,
      },
    ],
  },
]);

export default ApplicationRouter;
